import { useContext, useMemo } from "react";
import { ChatbotContext } from "../../chatbot.context";
import { ChatbotMediator } from "../../lib/mediator/chatbot.mediator";
import type { IChatbotMediator } from "../../lib/mediator/chatbot.mediator.interface";
import { ChatbotDispatcherService } from "../../lib/services/chatbot-dispatcher/chatbot.dispatcher.service";

export function useChatbotMediator(): IChatbotMediator {
  const { dispatch } = useContext(ChatbotContext);

  const chatbotMediator = useMemo(
    function createChatbotMediator() {
      const dispatcherService = new ChatbotDispatcherService(dispatch);
      return new ChatbotMediator(dispatcherService);
    },
    [dispatch]
  );

  return chatbotMediator;
}
